import store from "../init/store";
import type { MatchmakingErrorMessage } from "../_types/MatchmakingErrorMessage.js";

export function setBattleValue(changes: Object = {}) {
  store.dispatch({
    type: "SET_BATTLE_VALUE",
    payload: {
      changes: { ...changes }
    }
  });
}
export function setCombatantValue(key: string, changes: Object = {}) {
  store.dispatch({
    type: "SET_BATTLE_COMBATANT_VALUE",
    payload: {
      key: key,
      changes: { ...changes }
    }
  });
}

//Matchmaking
export function setMatchmakingValue(changes: Object = {}) {
  store.dispatch({
    type: "SET_MATCHMAKING_VALUE",
    payload: {
      changes: { ...changes }
    }
  });
}

export function setMatchmakingError(payload: MatchmakingErrorMessage) {
  setMatchmakingValue({ errorMessage: payload });
}

//Crew
export function setCrewValue(changes: Object = {}) {
  store.dispatch({
    type: "SET_CREW_VALUE",
    payload: {
      changes: { ...changes }
    }
  });
}



// WEBPACK FOOTER //
// ./src/redux-actions/battle-actions.js